import { LoggedUser } from "../../../redux/store";
import { Account } from "@idha/idha-types";
import * as R from "ramda";
import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import { hasPersonPermission, hasRole } from "redux/helperFunctions/loggedUser.helperFunctions";

export class GeneralAccessPermissions extends ModulePermissions {
    idhaAdminPersonManagement: boolean = false; //Esta opção é muito "grave", por isso já começa negada, para nao correr o risco de ser atribuida por engano
    userSettings: boolean = true;
    editAllUserSettings: boolean = true;
    editUsersRoles: boolean = true;
    personSettings: boolean = true;
    usersManagement: boolean = true;
    productManagement: boolean = true;
    productCategoryManagment: boolean = true;
    clientManagement: boolean = true;
    seeRegistrationMenu: boolean = true;
    cargoManagment: boolean = true;
    stockLocationManagment: boolean = true;
    paymentModalityManagment: boolean = true;
    paymentMethodManagment: boolean = true;
    costGroupManagment: boolean = true;
    commissionManagment: boolean = true;
    priceTableManagment: boolean = true;
    expenseManagment: boolean = true;
    productAquisitionCostManagment: boolean = true
    productSalesPriceManagment: boolean = true
    productPricingSettingsManagment: boolean = true
    generalPricingManagement: boolean = true

    constructor() {
        super();
    }
}

export class GeneralPermissionsPipeData extends PermissionsPipeData<GeneralAccessPermissions>{
    constructor(loggedUser: LoggedUser) {
        super(loggedUser, new GeneralAccessPermissions());
    }
}

namespace AccessRules {
    export function idhaAdmin(data: GeneralPermissionsPipeData) {
        data.permissions.idhaAdminPersonManagement = hasRole(data.loggedUser,'idhaAdmin');
        return data;
        
    }

    export function admin(data: GeneralPermissionsPipeData) {
        if (!hasRole(data.loggedUser,'admin')) {
            data.permissions.personSettings = false;
            data.permissions.productManagement = false;
            data.permissions.productCategoryManagment = false;
            data.permissions.clientManagement = false;
            data.permissions.usersManagement = false;
            data.permissions.editAllUserSettings = false;
            data.permissions.editUsersRoles = false;
            data.permissions.cargoManagment = false;
            data.permissions.stockLocationManagment = false;
            data.permissions.paymentModalityManagment = false;
            data.permissions.paymentMethodManagment = false;
            data.permissions.costGroupManagment = false;
            data.permissions.commissionManagment = false;
            data.permissions.priceTableManagment = false;
            data.permissions.expenseManagment = false;

        }

        return data;
    }

    export function store(data: GeneralPermissionsPipeData) {
        if (!hasPersonPermission(data.loggedUser,'orders-internal-management')) {
            data.permissions.cargoManagment = false;
            data.permissions.stockLocationManagment = false;
            data.permissions.paymentModalityManagment = false;
            data.permissions.paymentMethodManagment = false;
            data.permissions.costGroupManagment = false;
            data.permissions.commissionManagment = false;
            data.permissions.priceTableManagment = false;
            data.permissions.expenseManagment = false;
            data.permissions.productAquisitionCostManagment = false
            data.permissions.productSalesPriceManagment = false
            data.permissions.productPricingSettingsManagment = false
            data.permissions.generalPricingManagement = false
        }
        return data
    }

    export function seeRegistrationMenu(data: GeneralPermissionsPipeData) {

        if (!(data.permissions.productManagement ||
            data.permissions.productCategoryManagment ||
            data.permissions.personSettings ||
            data.permissions.clientManagement ||
            data.permissions.usersManagement ||
            data.permissions.editAllUserSettings ||
            data.permissions.editUsersRoles ||
            data.permissions.cargoManagment ||
            data.permissions.stockLocationManagment ||
            data.permissions.paymentModalityManagment ||
            data.permissions.paymentMethodManagment ||
            data.permissions.costGroupManagment ||
            data.permissions.commissionManagment ||
            data.permissions.priceTableManagment ||
            data.permissions.expenseManagment
        )) {
            data.permissions.seeRegistrationMenu = false
        }
        return data
    }


    export function end(data: GeneralPermissionsPipeData): GeneralAccessPermissions {
        return data.permissions
    }
}

export default R.pipe(
    AccessRules.idhaAdmin,
    AccessRules.admin,
    AccessRules.store,
    AccessRules.seeRegistrationMenu,
    AccessRules.end
);



